import React from "react";
import {withNamespaces} from "react-i18next";
import LandingArrowIcon from "../../ui/LandingArrowIcon";
import './style.less';
import HeroNewsStrip from "./HeroNewsStrip";

const statistics = [{
    value: 'landing.teasers.1.value', text: 'landing.teasers.1.text',
}, {
    value: 'landing.teasers.2.value', text: 'landing.teasers.2.text',
}, {
    value: 'landing.teasers.3.value', text: 'landing.teasers.3.text',
},];

const platformFeatureKeys = [
    "main.landing.hero.visual.features.documents",
    "main.landing.hero.visual.features.bidding",
    "main.landing.hero.visual.features.control",
];

function HeroSection({newsItems = [], t}) {
    return (<section className="landing-hero" id="platform">
        <div className="container">
            <div className="landing-hero__surface">
                <div className="landing-hero__content">
                    <h1 className="landing-hero__title">
                        {t("landing.title")}
                    </h1>

                    <p className="landing-hero__description">
                        {t("main.landing.hero.description")}
                    </p>

                    <div className="landing-hero__actions">
                        <a
                            href="/register"
                            className="landing-hero__button landing-hero__button--primary"
                        >
                            {t("landing.buttons.partners")}
                            <LandingArrowIcon/>
                        </a>

                        <a
                            href="#tariffs"
                            className="landing-hero__button landing-hero__button--secondary"
                        >
                            {t("main.landing.hero.viewTariffs")}
                        </a>
                    </div>

                    <div className="landing-hero__statistics">
                        {statistics.map((item) => (<div className="landing-hero__statistic" key={item.value}>
                            <div className="landing-hero__statistic-value">
                                {t(item.value)}
                            </div>

                            <div className="landing-hero__statistic-label">
                                {t(item.text)}
                            </div>
                        </div>))}
                    </div>
                </div>

                <div className="landing-hero__aside">
                    <div className="landing-hero__visual">
                        <div className="landing-hero__visual-header">
                            <div>
                                <div className="landing-hero__visual-caption">
                                    {t("main.landing.hero.visual.caption")}
                                </div>

                                <div className="landing-hero__visual-heading">
                                    {t("main.landing.hero.visual.heading")}
                                </div>
                            </div>

                            <div className="landing-hero__status">
                                <span/>
                                {t("main.landing.hero.visual.online")}
                            </div>
                        </div>

                        <div className="landing-hero__route">
                            <div className="landing-hero__route-point">
                                <span className="landing-hero__route-icon">
                                    {t("main.landing.hero.visual.route.loadingPoint")}
                                </span>

                                <div>
                                    <div className="landing-hero__route-label">
                                        {t("main.landing.hero.visual.route.loading")}
                                    </div>

                                    <div className="landing-hero__route-value">
                                        {t("main.landing.hero.visual.route.moscow")}
                                    </div>
                                </div>
                            </div>

                            <div className="landing-hero__route-line">
                                <span/>
                            </div>

                            <div className="landing-hero__route-point">
                                <span className="landing-hero__route-icon">
                                    {t("main.landing.hero.visual.route.unloadingPoint")}
                                </span>

                                <div>
                                    <div className="landing-hero__route-label">
                                        {t("main.landing.hero.visual.route.unloading")}
                                    </div>

                                    <div className="landing-hero__route-value">
                                        {t("main.landing.hero.visual.route.saintPetersburg")}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="landing-hero__features">
                            {platformFeatureKeys.map((featureKey, index) => (
                                <div className="landing-hero__feature" key={featureKey}>
                                    <span className="landing-hero__feature-number">
                                        {index + 1}
                                    </span>

                                    <span>{t(featureKey)}</span>

                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5.25 9.25L7.75 11.75L12.75 6.75"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>))}
                        </div>

                        <div className="landing-hero__visual-footer">
                            <div>
                                <span className="landing-hero__visual-footer-label">
                                    {t("main.landing.hero.visual.activeDeliveries")}
                                </span>

                                <strong>500+</strong>
                            </div>

                            <div>
                                <span className="landing-hero__visual-footer-label">
                                    {t("main.landing.hero.visual.carriers")}
                                </span>

                                <strong>10 000+</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <HeroNewsStrip items={newsItems}/>
            </div>
        </div>
    </section>);
}

export default withNamespaces("translation")(HeroSection);
